import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';

type VehicleCategory = 'all' | 'suv' | '4x4' | 'tourism' | 'sedan' | 'utility';

interface Vehicle {
  name: string;
  category: VehicleCategory;
  image: string;
  seats: number;
  features: string[];
}

const VehiclesPage = () => {
  const { t } = useTranslation();
  const [activeCategory, setActiveCategory] = useState<VehicleCategory>('all');

  const vehicles: Vehicle[] = [
    // SUV
    {
      name: "Toyota CH-R",
      category: "suv",
      image: "https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/5a933b238ffb1766d7e0b1a24cd5988b.jpeg",
      seats: 5,
      features: ["Hybride", "Faible consommation", "Compact"]
    },
    {
      name: "Nissan Juke",
      category: "suv",
      image: "https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/c090e5996e26d2e2989d254ec89b6668.jpeg",
      seats: 5,
      features: ["Compact", "Sportif", "Moderne"]
    },
    {
      name: "Acura RDX (Rouge)",
      category: "suv",
      image: "https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/6c4889d6d468343db33a4fca9beb8a51.jpeg",
      seats: 5,
      features: ["Luxe", "Performance", "Technologie"]
    },
    {
      name: "Acura RDX (Grise)",
      category: "suv",
      image: "https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/9b5c7e7fa9e0e27f1e4af9d3b5284cd0.jpeg",
      seats: 5,
      features: ["Luxe", "Performance", "Technologie"]
    },
    {
      name: "Lexus RX 350",
      category: "suv",
      image: "https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/454d4f7a728e86c8ff6169f3c9d6693f.jpeg",
      seats: 5,
      features: ["Premium", "Confort", "Spacieux"]
    },
    {
      name: "Peugeot 5008",
      category: "suv",
      image: "https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/f6a310283b797deed130b3ed27f0b045.jpeg",
      seats: 7,
      features: ["7 Places", "Spacieux", "Moderne"]
    },
    {
      name: "Toyota Highlander",
      category: "suv",
      image: "https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/c03796bf54204d1ec5989f163e6c1291.jpeg",
      seats: 7,
      features: ["Hybride", "Faible consommation", "7 Places"]
    },
    {
      name: "Honda CRV",
      category: "suv",
      image: "https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/239da3b1486f4da8c859aa08c7b976db.jpeg",
      seats: 5,
      features: ["Fiable", "Confortable", "Polyvalent"]
    },
    // 4x4
    {
      name: "Fortuner Executive BVA",
      category: "4x4",
      image: "https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/099ab6449dd1a474b986b45e3bbb7d51.jpeg",
      seats: 7,
      features: ["4WD", "Automatique", "Puissant"]
    },
    {
      name: "Prado TX-L BVA",
      category: "4x4",
      image: "https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/f61f1238c64cece253bbd29c23f8ca5a.jpeg",
      seats: 7,
      features: ["4WD", "Luxe", "Tout-terrain"]
    },
    {
      name: "Cadillac Escalade",
      category: "4x4",
      image: "https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/58ce28d57a1e4ce34d7d852c455bbe54.jpeg",
      seats: 7,
      features: ["Luxe", "Prestige", "Spacieux"]
    },
    // Tourism
    {
      name: "Jeep Wrangler",
      category: "tourism",
      image: "https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/7574b58e6127bed27af2898e139cea4f.jpeg",
      seats: 5,
      features: ["Hybride", "Faible consommation", "Aventure"]
    },
    {
      name: "4Runner",
      category: "tourism",
      image: "https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/0fdee3ed6671b9b973bad6b2eaa95eae.jpeg",
      seats: 5,
      features: ["Robuste", "Fiable", "Aventure"]
    },
    {
      name: "Mercedes-Benz Viano",
      category: "tourism",
      image: "https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/2a4eaea84e58262bd686239abc3e5e4d.jpeg",
      seats: 7,
      features: ["Luxe", "Confort", "7 Places"]
    },
    {
      name: "Petit bateau de plaisance",
      category: "tourism",
      image: "https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/7129bf2b6fe6c950f03dbf3eef84a33d.jpeg",
      seats: 6,
      features: ["Nautique", "Loisir", "Excursion"]
    },
    // Sedan
    {
      name: "Starlet Style BVM",
      category: "sedan",
      image: "https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/75f08305158575dfa13eadb3ce00e825.jpeg",
      seats: 5,
      features: ["Économique", "Compact", "Urbain"]
    },
    {
      name: "Toyota Camry",
      category: "sedan",
      image: "https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/bdd7b77261f69ea78a0b5824d36dd4a8.jpeg",
      seats: 5,
      features: ["Confort", "Élégant", "Business"]
    },
    // Utility
    {
      name: "Pick-Up RAM",
      category: "utility",
      image: "https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/5f72c576d7bf8da7c26cf5e6a751ed70.jpeg",
      seats: 5,
      features: ["Puissant", "Charge lourde", "Robuste"]
    },
    {
      name: "Pick-Up Hilux Double Cabine",
      category: "utility",
      image: "https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/1343644b450683a44fe836636eeaadd3.jpeg",
      seats: 5,
      features: ["Fiable", "Double cabine", "Polyvalent"]
    },
    {
      name: "Ford 250",
      category: "utility",
      image: "https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/dc7f6bcd8c0bada73743dd10d132c28f.jpeg",
      seats: 5,
      features: ["Heavy-duty", "Puissant", "Professionnel"]
    },
    {
      name: "Dyna",
      category: "utility",
      image: "https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/55483e7cb993bf85b4f881eb13bfc509.jpeg",
      seats: 3,
      features: ["Transport", "Commercial", "Fiable"]
    },
    {
      name: "Fourgonnette frigorifique",
      category: "utility",
      image: "https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/55cb9dd10e58b16509a9e0a0023e4928.jpeg",
      seats: 3,
      features: ["Livraison de produit frais", "Grande capacité", "Pratique"]
    },
    {
      name: "Camion de déménagement",
      category: "utility",
      image: "https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/81e76b18cf803b7562f15ff41c61d4da.jpeg",
      seats: 3,
      features: ["Transport", "Déménagement", "Pratique"]
    },
    {
      name: "Hyab",
      category: "utility",
      image: "https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/9826c258e360b6b5d237ea52af0356fd.jpeg",
      seats: 3,
      features: ["Grue", "Levage", "Transport lourd"]
    }
  ];

  const categories = [
    { id: 'all' as VehicleCategory, label: t('vehicles.all'), icon: 'ri-car-line' },
    { id: 'suv' as VehicleCategory, label: t('vehicles.suv'), icon: 'ri-car-line' },
    { id: '4x4' as VehicleCategory, label: t('vehicles.4x4'), icon: 'ri-roadster-line' },
    { id: 'tourism' as VehicleCategory, label: t('vehicles.tourism'), icon: 'ri-map-pin-line' },
    { id: 'sedan' as VehicleCategory, label: t('vehicles.sedan'), icon: 'ri-taxi-line' },
    { id: 'utility' as VehicleCategory, label: t('vehicles.utility'), icon: 'ri-truck-line' }
  ];

  const filteredVehicles = activeCategory === 'all' 
    ? vehicles 
    : vehicles.filter(v => v.category === activeCategory);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <section id="vehicles" className="py-12 sm:py-16 lg:py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-8 sm:mb-12">
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 sm:mb-4">
              {t('vehicles.title')}
            </h1>
            <p className="text-lg sm:text-xl text-gray-600 max-w-2xl mx-auto px-4">
              {t('vehicles.subtitle')}
            </p>
          </div>

          {/* Category Filter */}
          <div className="flex flex-wrap justify-center gap-3 sm:gap-4 mb-8 sm:mb-12">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setActiveCategory(category.id)}
                className={`flex items-center space-x-2 px-4 sm:px-6 py-2 sm:py-3 rounded-full font-semibold transition-all duration-300 whitespace-nowrap text-sm sm:text-base ${
                  activeCategory === category.id
                    ? 'bg-black text-white shadow-lg'
                    : 'bg-white text-gray-700 hover:bg-gray-100 shadow'
                }`}
              >
                <i className={`${category.icon} text-base sm:text-lg`}></i>
                <span>{category.label}</span>
              </button>
            ))}
          </div>

          {/* Vehicles Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 sm:gap-8">
            {filteredVehicles.map((vehicle, index) => (
              <div 
                key={index} 
                className="bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
              >
                <div className="relative">
                  <img
                    src={vehicle.image}
                    alt={vehicle.name}
                    className="w-full h-48 sm:h-56 object-cover object-top"
                    onError={(e) => {
                      e.currentTarget.src = 'https://via.placeholder.com/600x400?text=Image+Not+Found';
                    }}
                  />
                  <div className="absolute top-3 right-3 bg-yellow-400 text-black px-3 py-1 rounded-full text-xs font-semibold">
                    {vehicle.seats} {t('vehicles.seats')}
                  </div>
                </div>
                
                <div className="p-4 sm:p-5">
                  <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3">{vehicle.name}</h3>
                  
                  <div className="mb-4">
                    <div className="flex flex-wrap gap-2">
                      {vehicle.features.map((feature, featureIndex) => (
                        <span
                          key={featureIndex}
                          className="bg-gray-100 text-gray-700 px-2 sm:px-3 py-1 rounded-full text-xs"
                        >
                          {feature}
                        </span>
                      ))}
                    </div>
                  </div>

                  <a
                    href={`https://wa.me/237693695377?text=Bonjour, je souhaite réserver un ${vehicle.name}. Pouvez-vous me donner plus d'informations ?`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-full bg-black text-white py-2.5 sm:py-3 rounded-xl font-semibold hover:bg-gray-800 transition-colors flex items-center justify-center space-x-2 whitespace-nowrap text-sm"
                  >
                    <i className="ri-whatsapp-line"></i>
                    <span>{t('vehicles.book')}</span>
                  </a>
                </div>
              </div>
            ))}
          </div>

          {/* Show message if no vehicles found */}
          {filteredVehicles.length === 0 && (
            <div className="text-center py-12">
              <p className="text-gray-600 text-lg">
                {t('vehicles.noVehicles') || 'Aucun véhicule trouvé dans cette catégorie.'}
              </p>
            </div>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default VehiclesPage;



